import { Checkbox, IconButton, Paper } from "@mui/material";
import React, { useEffect, useRef } from "react";
import { useState, useCallback } from "react";
import CloseIcon from '@mui/icons-material/Close';

const isSmall = window.matchMedia("(max-width: 640px)").matches;
var months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const MerchatnsFilter = ({plans,close,setChecked}) => {

  const currentDate=useRef(new Date()).current
  const [{ month, year }, setDateCalender] = useState({ month: currentDate.getMonth(), year: currentDate.getFullYear() });
  const [filterErr,setFilterErr]=useState("")
  const [isLoading,setLoading]=useState(false)
  const [value,setValue]=useState("")
 

  
  const onConfirmFilter=()=>{
    if(!value) return setFilterErr("Please choose an option!")
    setChecked(value);
    setValue("")
    setFilterErr("")
    close()
  }
  const onClose=()=>{
    setValue("")
    // setFilterErr("")
    close()
  }
  const handlecheckChange = (txt) => setValue(txt);
  return (
    <div
      style={{
        // width: isSmall?"80%":"50%",
        height:300,
        width:350,
        alignSelf: "center",
        position:"absolute",
        top:20,
        right:10,
        // padding:5,
        backgroundColor: "#FFFFFF",
        boxShadow: "0px 4px 32px rgba(61, 70, 112, 0.08)",
        borderRadius:10,
        zIndex:99
      }}
    >
      <Paper sx={{p:"5px"}}>
        <div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              position: "relative",
              margin: "10px 0px",
            }}
          >
            <p
              style={{
                fontSize: 16,
                // fontFamily:"Inter",
                fontWeight: 700,
                color: "#1C1D22",
              }}
            >
             Filter Merchants
            </p>
            <div 
            //   onClick={()=>{
            //     setOpen(false);
            //     // setChecked("")
            //   }}
              style={{
                // position:"absolute",
                cursor:"pointer",
                alignSelf: "flex-end",
              }}
            >
            <IconButton onClick={onClose} type="button" sx={{ p: '10px',color:"#000000" }}  >
                <CloseIcon />
            </IconButton>
            </div>
          </div>
          {plans.length>0&&<div style={{ color: "#83898C",fontSize:16 }}>
            <h1 style={{marginLeft:10,color:"black",fontSize:18}}>Plan</h1>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                flexWrap:'wrap',
                // justifyContent: "space-between",
                marginBottom: 10,
              }}
            >
                {
                  plans.map((p,i)=>(
                        <div key={p} style={{width:"50%",display:"flex",alignItems:"center"}}>
                            <Checkbox
                            label={p}
                            checked={value == p}
                            onChange={() => {
                                handlecheckChange(p)
                                // setDates('tw')
                            }}
                            />
                            <p>{p}</p>
                        </div>
                    ))
                }
              
              
            </div>
            
          </div>}
          <div
            style={{ height: 1, backgroundColor: "gray", marginBottom: 20 }}
          ></div>
         <div>
            <p style={{fontWeight:"bold",color:"black",marginLeft:10}}>Plan Status</p>
            <div style={{
                display:"flex",
                justifyContent:"space-between"
            }}>
                <div style={{width:"50%",display:"flex",alignItems:"center"}}>
                    <Checkbox
                    label="Active"
                      checked={value == "active"}
                      onChange={() => {
                        handlecheckChange("active")
                        // setDates('lw')
                      }}
                    />
                    <p>Active</p>
                </div>
                <div style={{width:"50%",display:"flex",alignItems:"center"}}>
                    <Checkbox
                    label="Cancelled"
                      checked={value == "cancelled"}
                      onChange={() => {
                        handlecheckChange("cancelled")
                        // setDates('lw')
                      }}
                    />
                    <p>Cancelled</p>
                </div>
            </div>
         </div>
          
        </div>
        
        <div style={{ margin: "10px 0px" }}>
            
                  <button
                    style={{
                      backgroundColor: "#3980FD",
                      opacity: 5,
                      border: 0,
                      width: "100%",
                      height: 35,
                      borderRadius: 6,
                      color: "white",
                      cursor: "pointer",
                      boxShadow:
                        "0px 4px 6px -4px rgba(58, 53, 65, 0.1), 0px 6px 10px -4px rgba(58, 53, 65, 0.08), 0px 4px 8px -4px rgba(58, 53, 65, 0.16)",
                    }}
                    onClick={onConfirmFilter}
                  >
                    {isLoading? "loading...": "Filter"}
                  </button>
          <div>
            <p style={{color:"red",margin:"5px 0"}}>{filterErr}</p>
          </div>
        </div>
        
      </Paper>
    </div>
  );
};

export default MerchatnsFilter;
